module.exports = __webpack_public_path__ + "static/img/3.ad90e42.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/sp/3.png
// module id = 8a+K
// module chunks = 0